import { createSelector } from 'reselect';
import { actions as offerReduxActions } from '@makemydeal/dr-offer-redux';
import type { StateTree } from '@makemydeal/dr-dash-types';
import * as deskingSelectors from './deskingSelectors';
import * as offerReduxSelectors from './offerRedux';

export const getCalculatedPaymentFrequency = createSelector(
    [
        (state: StateTree) => deskingSelectors.wasTheLastFailure(offerReduxActions.UPDATED_PAYMENT_FREQUENCY)(state),
        offerReduxSelectors.getOfferPaymentFrequency,
        offerReduxSelectors.getPaymentFrequency
    ],
    (failedPaymentFrequency, offerInputPaymentFrequency, defaultPaymentFrequency) => {
        return failedPaymentFrequency ? defaultPaymentFrequency : offerInputPaymentFrequency || defaultPaymentFrequency;
    }
);
